import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useState, Fragment } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../Ventas.module.css';
import PercentTip from '../../../components/PercentTip/PercentTip';

const YearGrowth = props => {
	const { data, endDate, isLoading, initialDate } = props;

	const [booleanMayor, setBooleanMayor] = useState(false);
	const [percentChange, setPercentChange] = useState('');

	const actualBill = data.totalBillActual;
	const lastBill = data.totalBillAnterior;

	const [monthYear, setMonthYear] = useState('');
	const [monthYearInitial, setMonthYearInitial] = useState('');

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		const updateHook = async () => {
			if (isLoading === false) {
				setPercentChange(((actualBill - lastBill) / lastBill) * 100);
			}
		};
		updateHook();
	}, [isLoading, lastBill, actualBill]);

	useEffect(() => {
		const updatePercent = async () => {
			if (percentChange !== 0) {
				if (percentChange < 0) {
					setBooleanMayor(true);
				} else {
					setBooleanMayor(false);
				}
			}
		};
		updatePercent();
	}, [percentChange]);

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(endDate));
			setMonthYearInitial(formatDate(initialDate));
		}
	}, [isLoading, endDate, initialDate]);

	return (
		<React.Fragment>
			<div className={classes.date}>{monthYear}</div>
			{isLoading ? (
				<CircularProgress />
			) : (
				<div className={classes.number}>
					<NumberFormat value={actualBill} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={0} />

					{booleanMayor ? (
						<FontAwesomeIcon className={classes.faArrowDown} icon={faArrowDown} />
					) : (
						<FontAwesomeIcon className={classes.faArrowUp} icon={faArrowUp} />
					)}
					<br></br>
					<div className={classes.percent}>
						<Fragment>
							<div className={classes.percent}>
								<PercentTip
									value={<NumberFormat value={percentChange} displayType={'text'} decimalScale={2} suffix={'%'} />}
									percentChange={percentChange}
									text={
										<Fragment>
											<div>Comparación con {monthYearInitial}</div>
											<br></br>
											<div>
												<NumberFormat
													value={lastBill}
													displayType={'text'}
													thousandSeparator={true}
													prefix={'US$'}
													decimalScale={0}
												/>
											</div>
										</Fragment>
									}
								/>
							</div>
						</Fragment>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default React.memo(YearGrowth);
